import { render, staticRenderFns } from "./Enviado.vue?vue&type=template&id=3bba0b8a&"
import script from "./Enviado.vue?vue&type=script&lang=js&"
export * from "./Enviado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports